/* @flow */

import * as React from 'react';

import { ScrollView, View } from 'react-native-web';

type PropsFlowType = {
  ItemSeparatorComponent?: React.ComponentType<any>,
  ListFooterComponent?: React.ComponentType<any>,
  ListHeaderComponent?: React.ComponentType<any>,
  contentContainerStyle?: Object,
  data?: Array<any>,
  horizontal?: boolean,
  keyExtractor?: (item: any) => string,
  renderItem: (obj: { index: number, item: any }) => ?React.Element<any>,
  style?: Object,
};

const FlatList = ({
                    ItemSeparatorComponent,
                    ListFooterComponent,
                    ListHeaderComponent,
                    contentContainerStyle = {},
                    data = [],
                    horizontal = false,
                    keyExtractor,
                    renderItem,
                    style = {},
                  }: PropsFlowType = {}): React.Node => (
  <ScrollView
    contentContainerStyle={contentContainerStyle}
    horizontal={horizontal}
    style={style}
  >

    {ListHeaderComponent &&
    <ListHeaderComponent/>
    }

    {data.map((item, index): React.Node => (
      <View
        key={keyExtractor ? keyExtractor(item) : index}
      >

        {renderItem({index, item})}

        {(ItemSeparatorComponent && index < data.length - 1) &&
        <ItemSeparatorComponent/>
        }

      </View>
    ))}

    {ListFooterComponent &&
    <ListFooterComponent/>
    }

  </ScrollView>
);

export default FlatList;



// WEBPACK FOOTER //
// ./src/components/FlatList.web.js